(() => {
  if (customElements.get('product-popup')) {
    return;
  }

class ProductPopup extends HTMLElement {
    constructor() {
        super();
        this.popupCloser = this.querySelector('button[data-popup-closer]');
        if (this.popupCloser) this.popupCloser.addEventListener('click', this.hidePopup.bind(this));
    }
    hidePopup() { 
        this.classList.add('hidden');
    }
}

  customElements.define('product-popup', ProductPopup);
})();
